import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse }
from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, map, retry, tap } from 'rxjs/operators';
import { CryptoServices } from './CryptoServices';
import { ObjectUtil } from '../system-utils/utils/ObjectUtil';
import { throwError } from 'rxjs';
import { ConnectionLostBarService } from './ConnectionLostBarService';
@Injectable()


export class InterceptorHttp implements HttpInterceptor {

  constructor(private cryptoServices:CryptoServices, private bar: ConnectionLostBarService){

  }
  

  intercept( request: HttpRequest<any>, next: HttpHandler ):Observable<HttpEvent<any>> {
      return next.handle(request).pipe(
        catchError((error) => {
          if (error instanceof HttpErrorResponse && error.status === 0) {
            this.bar.show();
          }
          return throwError(() => error);
        }),
        map(evt=>{
        
        if (evt instanceof HttpResponse) {
            if ( this.bar.offline() ){
                 this.bar.hide(); 
            }
            if ( ObjectUtil.isNotEmpty(evt.body)){
              if ( ObjectUtil.isNotEmpty(evt.body.value)){
                try{
                  return evt.clone({
                    body: JSON.parse(this.cryptoServices.decrypt(evt.body.value))
                  })
                }catch(Exception){
                  console.log(this.cryptoServices.decrypt(evt.body.value));
                }
                
              }else{
                return evt.clone({
                    body: evt.body
                } )
              }
            }else{
              return evt.clone({
                body: {}
              } )
            }  
        }else{
           return evt;
        }
      }))
  }

}